export default __webpack_public_path__ + "static/media/malibu.f1d5acfe.png";